import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BackboneAdapterService } from '../../../../shared/backbone-adapter.service';
import { GTMService } from '../../../../shared/gtm.service';
import { NotificationService } from '../../../../shared/notification.service';
import { OneSignalService } from '../../../../shared/one-signal.service';
import { StringTransformHelper } from '../../../../shared/string-transform.helper';
import { LiveClassDto } from '../../../../shared/types/LiveClassDto';
import { LiveClassEventService } from '../../../live-class-event.service';
import { FutureClassTile } from '../../../live-class-section/class-tile/future-class-tile';
import { GroupClassTile } from '../../../live-class-section/class-tile/group-class-tile';
import { LiveClassTile } from '../../../live-class-section/class-tile/live-class-tile';
import { LiveClassService } from '../../../live-class.service';

@Component({
  selector: 'lp2-group-class-tile',
  templateUrl: './group-class-tile.component.html',
  styleUrls: ['./group-class-tile.component.scss'],
})
export class GroupClassTileComponent implements OnInit {
  @Input() liveClass: LiveClassDto;
  @Input() showDescription: boolean = true;

  public classTypeTranslationKey: string;
  public typeDescription: string;
  public imageUrl: SafeResourceUrl;
  public liveClassTile: LiveClassTile | FutureClassTile;

  constructor(
    private liveClassService: LiveClassService,
    private liveClassEventService: LiveClassEventService,
    private notificationService: NotificationService,
    private backbone: BackboneAdapterService,
    private gtmService: GTMService,
    private oneSignalService: OneSignalService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.liveClassTile = new GroupClassTile(
      this.liveClassService,
      this.liveClassEventService,
      this.notificationService,
      this.backbone,
      this.gtmService,
      this.oneSignalService,
      'pcrevamp',
      this.liveClass
    );

    const camelCaseSubType = StringTransformHelper.toCamelCase(this.liveClass.subType);
    this.classTypeTranslationKey = `studybundle.liveClasses.${camelCaseSubType}`;
    this.typeDescription = `studybundle.liveClasses.${camelCaseSubType}Tooltip`;
    this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.liveClass.img);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile.component.ts